import React from 'react';
import { profile } from '../data/profile';
type PortraitFrameProps = {
  size?: 'lg' | 'sm';
};
export function PortraitFrame({
  size = 'lg'
}: PortraitFrameProps) {
  const isLarge = size === 'lg';
  return <figure className={`relative mx-auto w-full ${isLarge ? 'max-w-md' : 'max-w-[15rem]'}`} data-id="element-62" data-mp="1phqwhd01xwig">
      <div aria-hidden="true" className="absolute -inset-3 border border-gold-500/35 sm:-inset-4" data-id="element-63" data-mp="1kkik5t1l4mp4" />
      <div aria-hidden="true" className="absolute -inset-6 hidden border border-white/10 sm:block sm:-inset-8" data-id="element-64" data-mp="2i6odlcsj1n9m" />
      <span aria-hidden="true" className="absolute -left-4 -top-4 h-6 w-px bg-gold-500 sm:-left-5 sm:-top-5" data-id="element-65" data-mp="28hejxsi1bwje" />
      <span aria-hidden="true" className="absolute -left-4 -top-4 h-px w-6 bg-gold-500 sm:-left-5 sm:-top-5" data-id="element-66" data-mp="23il2jozmnldy" />
      <span aria-hidden="true" className="absolute -bottom-4 -right-4 h-6 w-px bg-gold-500 sm:-bottom-5 sm:-right-5" data-id="element-67" data-mp="30y8tbe7ka15m" />
      <span aria-hidden="true" className="absolute -bottom-4 -right-4 h-px w-6 bg-gold-500 sm:-bottom-5 sm:-right-5" data-id="element-68" data-mp="2w5xpw1dm3x8b" />

      <div className="relative border-2 border-gold-500/70 bg-navy-800 p-2" data-id="element-69" data-mp="1njozl7s9on7g">
        <div className="relative overflow-hidden border border-white/10" data-id="element-70" data-mp="1sh8g6ecftc2k">
          <img src={profile.portrait} alt={`Portrait of ${profile.name}`} className="block aspect-square w-full object-cover object-top" loading="eager" data-id="element-71" data-mp="1dtvr4fnf8o7f" />
        </div>
      </div>

      <figcaption className={`relative border-x-2 border-b-2 border-gold-500/70 bg-navy-800 px-6 text-center ${isLarge ? 'pb-7 pt-6' : 'pb-5 pt-4'}`} data-id="element-72" data-mp="14r4dc972pgcm">
        <span aria-hidden="true" className="mx-auto mb-5 block h-px w-12 bg-gold-500" data-id="element-73" data-mp="uvt8qjpdppil" />
        <p className={`font-display font-extrabold uppercase tracking-[0.14em] text-white ${isLarge ? 'text-xl sm:text-2xl' : 'text-base'}`} data-id="element-74" data-mp="zst68685xjy3">
          {profile.name}
        </p>
        <p className={`mx-auto mt-3 max-w-xs font-sans font-medium leading-relaxed text-gold-400 ${isLarge ? 'text-sm' : 'text-xs'}`} data-id="element-75" data-mp="2u73sq81ac20p">
          Director &amp; Enterprise Leader
        </p>
        <p className={`mx-auto mt-1.5 max-w-xs font-sans leading-relaxed text-platinum-300 ${isLarge ? 'text-sm' : 'text-xs'}`} data-id="element-76" data-mp="2ntq3zv63r4i9">
          Analytics, Data &amp; AI Governance
        </p>
      </figcaption>
    </figure>;
}